import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {IndexRoute, Route, Router} from "react-router";
import "./css/App.css";
import "./css/base.css";
import "./css/colpick.css";
import "../node_modules/gasparesganga-jquery-loading-overlay/src/loadingoverlay";
import App from "./App.js";
import Home from "./componentsBody/Home.js";
import Messages from "./componentsBody/Messages.js";
import VideoPlayerWrapper from "./componentsBody/VideoPlayerWrapper.js";
import NotFound from "./componentsBody/NotFound.js";
import AboutPage from "./componentsBody/AboutPage.js";
import store from "./store.js";
import history from "./history.js";

ReactDOM.render((
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={App}>
                <IndexRoute component={Home}/>
                <Route path="messages" component={Messages}/>
                <Route path="v/:vid" component={VideoPlayerWrapper}/>
                <Route path="about" component={AboutPage}/>
                <Route path="*" component={NotFound}/>
            </Route>
        </Router>
    </Provider>
), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js